<template>
        <div v-if="CallUserModal" style=" z-index: 100000000 !important;"  class="modal-container ">
        <div class="modal-dialog modal-xl modal-info" style="max-width:1246px !important">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-center">{{ CompanyName }} Meeting</h4>

                    <div class="col-3">
                        <a @click="close()" class="modal-close"><i class="fa fa-times"></i></a>

                    </div>
                </div>
                <div class="modal-body container" style="margin-bottom:10px; max-height:600px">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-12">
                            <label>Name:<span class="text-danger">*</span></label>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Enter Your Name"
                                    @input="IsValidUserName()" maxlength="50" v-model="username"
                                    :class="{ 'is-invalid': invalidUserName }" />

                                <small v-if="invalidUserName" class="text-danger">Name is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0);" class="btn btn-primary" @click="save()">Submit</a>
                    </div>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-danger form-btns" @click="close()" data-dismiss="modal"
                        aria-label="Close">
                        <vue-feather type="x" size="18"></vue-feather>
                       
                        End Call
                    </button>
                </div> -->
            </div>
        </div>
    </div>
    <div   class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div style="max-width:40% !important;" class="modal-dialog modal-xl modal-info " :class="{ 'disabled': loadSave }">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-center">{{ CompanyName }} Meeting</h4>
                </div>
                <div class="modal-body container" style=" margin-bottom:10px; max-height:600px">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-12">
                            <label>Name:<span class="text-danger">*</span></label>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Enter Your Name"
                                    @input="IsValidUserName()" maxlength="50" v-model="username"
                                    :class="{ 'is-invalid': invalidUserName }" />

                                <small v-if="invalidUserName" class="text-danger">Name is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0);" class="btn btn-primary" @click="save()">Submit</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div bsModal :config="{ backdrop: 'static' }" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div style="max-width:40% !important;" class="modal-dialog modal-xl modal-info " :class="{ 'disabled': loadSave }">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-center">{{ CompanyName }} Meeting</h4>
                </div>
                <div class="modal-body container" style=" margin-bottom:10px; max-height:600px">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-12">
                            <h4 v-if="!isActiveRoom" class="text-center">Link has been expired</h4>
                            <h4 v-if="isFull" class="text-center">Room is already full</h4>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0);" class="btn btn-primary" @click="close()">Ok</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Videocallheader v-if="blnUserNameSelect" :joinerName='username' />
    <!-- <app-videocallheader v-if="blnUserNameSelect" :joinerName='username'></app-videocallheader> -->
    <div v-if="blnUserNameSelect" class="row mt-4">
        <div class="col-12">
            <div class="grid-left">
                <Rooms ref="rooms" :isOwner="false" @roomChanged="onRoomChanged($event)"
                    @participantCount="getParticipantsCount($event)"
                    :defaultRoom="!!activeRoom ? activeRoom.name : roomName" :activeRoomName="activeRoom?.name" />
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- <app-participants #participants [isOwner]="false" [isFull]="isFull"
                        (participantsChanged)="onParticipantsChanged($event)"
                        [activeRoomName]="!!activeRoom ? activeRoom.name : null"
                        [activeRoom]="!!activeRoom ? activeRoom : null">
                    </app-participants> -->

                    <Participants ref="participants" :userName="userName" :isOwner="false" :isFull="isFull"
                        @leaveRoom="onLeaveRoom($event)" @participantsChanged="onParticipantsChanged($event)"
                        :activeRoomName="!!activeRoom ? activeRoom.name : null"
                        :activeRoom="!!activeRoom ? activeRoom : null" />
                </div>
            </div>
            <!-- <app-camera ref=camera class="app-camera" :userName="username"   @leaveRoom="onLeaveRoom($event)"
                :isOwner="false"></app-camera> -->

            <!-- <Camera ref="camera" class="app-camera" :userName="userName" @leaveRoom="onLeaveRoom($event)"
                :isOwner="false" /> -->

                <Camera ref="camera" class="app-camera" :userName="userName" @setMuteAudio="setMuteAudio($event)"  @setMuteVideo = "muteVideo($event)"  @leaveRoom="onLeaveRoom($event)"
                        :isOwner="false" />

            <div class="row">
                <!-- <app-settings #settings (settingsChanged)="onSettingsChanged($event)">
                </app-settings> -->

                <Settings ref="settings" @settingsChanged="onSettingsChanged($event)" />
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref,toRaw, getCurrentInstance } from 'vue'
import { useRouter, useRoute } from "vue-router";
import Rooms from "../rooms/rooms.vue";
import Participants from "../participants/participants.vue";
import Settings from "../settings/settings.vue";
import Camera from "../camera/camera.vue";
import { createToaster } from "@meforma/vue-toaster";
import CommonService from "@/service/crmservice/commonService";
import VideoChatService from "@/service/crmservice/videochat.service";
import Videocallheader from "../videocallheader/videocallheader.vue"
import { createLocalAudioTrack } from 'twilio-video';
import { videoChatStore } from '@/store/videochat'
import { MuteUnmuteOptions } from '@/service/crmservice/videochat.service';

export default {
    name: 'videoChat',
    components: {
        Rooms,
        Participants,
        Settings,
        Camera,
        Videocallheader
    },
    props: {

    },
    setup() {

        //================== variable =====================

        const commonService = ref(new CommonService());
        const videoChatService = ref(new VideoChatService());
        const toaster = createToaster({ position: "top-right" });
        const thisApp = getCurrentInstance();
        const filters = thisApp.appContext.config.globalProperties.$filters;
        const route = useRoute();
        const videoModal = ref(null);
        const rooms = ref(null);
        const camera = ref(null);
        const settings = ref(null);
        const participants = ref(null);
        const CallUserModal = ref(false);
        const IsFullOrNonActive = ref(null);
        const createRoom = ref(true);
        const phoneNo = ref('');
        const roomsList = ref([]);
        const activeRoom = ref(null);
        const loadSave = ref(null);
        const joinId = ref(null);
        const companyId = ref(null);
        const CompanyName = ref(null);
        const roomName = ref(null);
        const blnMuteVideo = ref(false);
        const blnMuteAudio = ref(false);
        const isFull = ref(false);
        const username = ref("");
        const invalidUserName = ref(false);
        const blnUserNameSelect = ref(false);
        const notificationHub = ref(null);
        const participantCount = ref(null);
        const isActiveRoom = ref(false);
        const videoStore = videoChatStore();

        //================== Funcation =====================

        const close = () => {
            let wind = window.open('', '_self')
            wind.close();
            window.history.go(-1);
        }

        const IsValidUserName = () => {
            if (username.value.length < 1 || username.value == undefined) {
                invalidUserName.value = true;
                return
            }
            else {
                invalidUserName.value = false;
                return
            }
        }

        const save = () => {
            if (username.value.length < 1 || username.value == undefined) {
                invalidUserName.value = true;
                return
            }
            blnUserNameSelect.value = true;
            CallUserModal.value = false
            setTimeout(async () => {
                await createRooms();
            }, 100);
        }
        const getRooms = async (joinId, companyId) => {
            roomsList.value = await videoChatService.value.joinRooms(joinId, companyId);
            return roomsList.value;
        }

        const createRooms = () => {
            rooms.value.getRooms(joinId.value, companyId.value).then(async (arg) => {
                if (arg.data.length > 0) {
                    if (arg.data[0].participantCount <= 3 && arg.data[0].isActive) {
                        await addParticipant(arg.data[0].name);
                    } else {
                        isFull.value = true;
                        toaster.success("Room is already full!");
                    }
                } else {
                    toaster.success("Something went wrong while joining. Please reload the page.");
                }
            });
        }


        const addParticipant = async (name) => {
            onRoomChanged(name);
            // const builder =
            //     new HubConnectionBuilder()
            //         .configureLogging(LogLevel.Information)
            //         .withUrl(`${location.origin}/notificationHub`);
            // notificationHub.value = builder.build();
            // notificationHub.value.on('RoomsUpdated', async updated => {
            //     if (updated) {
            //         await rooms.getRooms(joinId, companyId);
            //     }
            // });
            // await notificationHub.value.start();
        }


        const getParticipantsCount = async (count) => {
            if (count) {
                participantCount.value = count;
            }
        }


        const onSettingsChanged = async (deviceInfo) => {
            await camera.value.initializePreview(deviceInfo.deviceId);
            if (settings.value.isPreviewing) {
                const track = await settings.value.showPreviewCamera();
                if (activeRoom.value) {
                    username.value = activeRoom.value.localParticipant.identity;
                    const localParticipant = activeRoom.value.localParticipant;
                    localParticipant.videoTracks.forEach(publication => publication.unpublish());
                    await localParticipant.publishTrack(track);
                }
            }
        }


        const onLeaveRoom = async (_) => {
            if (activeRoom.value) {
                const leaveRoom = toRaw(activeRoom.value);
                leaveRoom.disconnect();
                activeRoom.value = null;
            }
            const videoDevice = settings.value.hidePreviewCamera();
            await camera.value.initializePreview(videoDevice && videoDevice.deviceId);
            participants.value.clear();
            let wind = window.open('', '_self')
            wind.close();
            window.history.go(-1);
        }


        const onRoomChanged = async (roomName) => {
            if (roomName) {
                if (activeRoom.value) {
                    activeRoom.value.disconnect();
                }

                let showCamer = await settings.value.showPreviewCamera()
                const formAsPlainObject = toRaw(showCamer);

                const tracks = await Promise.all([
                    createLocalAudioTrack(),
                    formAsPlainObject
                ]);
                if (tracks[1]) {
                    activeRoom.value =
                        await videoChatService.value
                            .joinOrCreateRoom(username.value, roomName, tracks, companyId.value);

                    if (activeRoom.value) {
                        const plainactiveRoom = toRaw(activeRoom.value)
                        participants.value.initialize(plainactiveRoom.participants);
                        username.value = plainactiveRoom.localParticipant.identity;
                        registerRoomEvents();
                        //notificationHub.value.send('RoomsUpdated', true);
                    } else {
                        toaster.success("No active room found. Please reload the page.");
                    }
                } else {
                    toaster.success("Unable to create video tracks. Camera is already in use by other application.");
                }

            }
        }

        const onParticipantsChanged = async(event) => {
            // videoChatService.value.nudge();
            
        }

        const registerRoomEvents = () => {
            activeRoom.value
                .on('disconnected',
                    (room) => room.localParticipant.tracks.forEach(publication => detachLocalTrack(publication.track)))
                .on('participantConnected',
                    (participant) => participants.value.add(participant))
                .on('participantDisconnected',
                    (participant) => participants.value.remove(participant))
                .on('dominantSpeakerChanged',
                    (dominantSpeaker) => participants.value.loudest(dominantSpeaker));
        }

        const detachLocalTrack = (track) => {
            if (isDetachable(track)) {
                track.detach().forEach(el => el.remove());
            }
        }

        const isDetachable = (track) => {
            return !!track
                && ((track).detach !== undefined
                    || (track).detach !== undefined);
        }


        const muteVideo = (event) => {
            console.log("event",event)
            const param = new MuteUnmuteOptions();
            param.video = true;
            if (event) {
                mute(param);
            } else {
                unmute(param);
            }
        }


        const setMuteAudio = (event) => {
            const param = new MuteUnmuteOptions();
            param.audio = true;
            if (event) {
                mute(param);
            } else {
                unmute(param);
            }
        }


        const mute = (opts) => {
            console.log("opts-mute", opts)
            let muteactiveRoom = toRaw(activeRoom.value)
            if (!muteactiveRoom || !muteactiveRoom.localParticipant)
                throw new Error("You must be connected to a room to mute tracks.");

            if (opts.audio) {
                muteactiveRoom.localParticipant.audioTracks.forEach((publication) =>
                    publication.track.disable()
                );
            }

            if (opts.video) {
                muteactiveRoom.localParticipant.videoTracks.forEach((publication) =>
                    publication.track.disable()
                );

                activeRoom.value = muteactiveRoom;
                // activeRoom.value.participants.forEach(participant => {
                //     participant.tracks.forEach(publication => {
                //         if (publication.track) {
                //             console.log("participants.value", participants.value)
                //             console.log("publication.track.attach()",publication.track.attach())
                //             document.getElementById('remote-media-div').appendChild(publication.track.attach());
                //         }
                //     });

                //     participant.on('trackSubscribed', track => {
                //         console.log("track.attach()", track.attach());
                //         document.getElementById('remote-media-div').appendChild(track.attach());
                //     });
                // });
            }
        };


        const unmute = (opts) => {
            console.log("opts-unmute", opts)
            console.log("activeRoom.value",activeRoom.value)
            let muteactiveRoom = toRaw(activeRoom.value)
            console.log("muteactiveRoom",muteactiveRoom)
            if (!muteactiveRoom || !muteactiveRoom.localParticipant)
                throw new Error("You must be connected to a room to unmute tracks.");

            if (opts.audio) {
                muteactiveRoom.localParticipant.audioTracks.forEach((publication) =>
                    publication.track.enable()
                );
            }

            if (opts.video) {
                muteactiveRoom.localParticipant.videoTracks.forEach((publication) =>
                    publication.track.enable()
                );
            }

            activeRoom.value = muteactiveRoom;
        };


        // const mute = (opts) => {
        //     if (!activeRoom.value || !activeRoom.value.localParticipant)
        //         throw new Error('You must be connected to a room to mute tracks.');

        //     if (opts.audio) {
        //         activeRoom.value.localParticipant.audioTracks.forEach(
        //             publication => publication.track.disable()
        //         );
        //     }

        //     if (opts.video) {
        //         activeRoom.value.localParticipant.videoTracks.forEach(
        //             publication => publication.track.disable()
        //         );
        //     }
        // }

        // const unmute = (opts) => {
        //     console.log("opts", opts)
        //     console.log("activeRoom.value", activeRoom.value);
        //     if (!activeRoom.value || !activeRoom.value.localParticipant)
        //         throw new Error('You must be connected to a room to unmute tracks.');

        //     if (opts.audio) {
        //         activeRoom.value.localParticipant.audioTracks.forEach(
        //             publication => publication.track.enable()
        //         );
        //     }

        //     if (opts.video) {
        //         activeRoom.value.localParticipant.videoTracks.forEach(
        //             publication => publication.track.enable()
        //         );
        //     }
        // }

        //================== OnMounted =====================
        onMounted(() => {

            console.log("Video Chat Route", route);
            // $('.main-content').addClass('video-chat-screen');
            // const result = videoStore.MuteVideo;
            // console.log("result",result)
            // const param = new MuteUnmuteOptions();
            //     param.video = true;
            //     if (result) {
            //         mute(param);
            //     } else {
            //         unmute(param);
            //     }

            // commonService.value.getVideoSubject.then((res) => {
            //     onLeaveRoom.value(true);
            // })
            // const muteAudio = videoStore.MuteAudio;
            // const params = new MuteUnmuteOptions();
            //     params.audio = true;
            //     if (muteAudio) {
            //         mute(params);
            //     } else {
            //         unmute(params);
            //     }

            setTimeout(() => {
                if (route.query) {
                console.log("route.query-1",route.query)
                joinId.value = route.query.joinId;
                companyId.value = route.query.companyId;

                }

                commonService.value.GetCompanyName(companyId.value).then(
                (result) => {
                    if (result)
                        CompanyName.value = result.data;
                    console.log("CompanyName.value", CompanyName.value);
                    getRooms(joinId.value, companyId.value).then(async (arg) => {
                        console.log("arg", arg);
                        if (arg.data.length > 0) {
                            if (arg.data[0].isActive) {
                                if (arg.data[0].participantCount <= 3) {
                                    if (!blnUserNameSelect.value) {
                                        setTimeout(() => {
                                            console.log("CallUserModal.value",CallUserModal.value)
                                            CallUserModal.value = true;
                                            console.log("CallUserModal.value",CallUserModal.value)
                                        });
                                    } else {
                                        await createRooms();
                                    }
                                } else {
                                    isActiveRoom.value = true;
                                    isFull.value = true;
                                    setTimeout(() => {
                                        IsFullOrNonActive.value.show();
                                    });
                                }
                            } else {
                                isFull.value = false;
                                isActiveRoom.value = false;
                                setTimeout(() => {
                                    IsFullOrNonActive.value.show();
                                });
                            }
                        } else {
                            isActiveRoom.value = false;
                            setTimeout(() => {
                                IsFullOrNonActive.value.show();
                            });
                        }
                    });
                });
                
            }, 3000);

           




         
        })

        //================== return =====================
        return {
            videoModal,
            rooms,
            camera,
            settings,
            participants,
            CallUserModal,
            IsFullOrNonActive,
            createRoom,
            phoneNo,
            roomsList,
            activeRoom,
            loadSave,
            joinId,
            companyId,
            CompanyName,
            roomName,
            blnMuteVideo,
            blnMuteAudio,
            isFull,
            username,
            invalidUserName,
            blnUserNameSelect,
            notificationHub,
            participantCount,
            isActiveRoom,
            getRooms,
            save,
            IsValidUserName,
            close,
            getParticipantsCount,
            addParticipant,
            onSettingsChanged,
            onLeaveRoom,
            isDetachable,
            detachLocalTrack,
            registerRoomEvents,
            onParticipantsChanged,
            onRoomChanged,
            mute,
            unmute,
            muteVideo,
            setMuteAudio
        }
    },
}
</script>

<style>
.main-content {
    margin: 0px !important;
}

.grid-container {
    display: grid;
    height: 100vh;
    grid-template-columns: 2fr 4fr 2fr;
    grid-template-rows: 1fr 7fr 1fr;
    grid-template-areas: "top-left . top-right" "left content right" "bottom-left . bottom-right";
}

.grid-content {
    grid-area: content;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-left {
    grid-area: left;
}

.grid-right {
    grid-area: right;
}

.grid-top-left,
.grid-top-right,
.grid-bottom-left,
.grid-bottom-right {
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-top-left {
    grid-area: top-left;
}

.grid-top-right {
    grid-area: top-right;
}

.grid-bottom-left {
    grid-area: bottom-left;
}

.grid-bottom-right {
    grid-area: bottom-right;
}

div.grid-bottom-right>a {
    color: #1da1f2;
    font-size: 2rem;
}

div.grid-bottom-right>a:hover {
    color: #96cff2;
}

.grid-top-left>img {
    max-height: 60px;
    max-width: 225px;
}

@media only screen and (max-height: 1000px) {
    .grid-top-left>img {
        max-height: 50px;
        max-width: 187.5px;
    }
}

.grid-top-left>a:hover>img {
    filter: brightness(110%);
}

#preview {
    position: absolute;
    width: 218px !important;
    height: 168px !important;
    border: 1px solid #a1a1a1;
    padding: 10px;
    display: block;
    bottom: -5px;
    z-index: 10000;
    left: 50%;
    background: #ffffff;
    margin-left: -109px;
}

.part-list {
    display: flex;
    justify-content: space-between;
}
</style>

